import VueI18n from 'vue-i18n';
import Messages from './messages';
import Vue from 'vue';

Vue.use(VueI18n);

export default new VueI18n({
	locale: 'es',
	messages: Messages
});
